import ErrorState from 'components/standard/ErrorState';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Button from '@liquidweb-dev/undercurrent/Button';
import DrawerContent from '@liquidweb-dev/undercurrent/DrawerContent';
import DrawerFooter from '@liquidweb-dev/undercurrent/DrawerFooter';

interface BackupSettingsErrorProps {
	onClose?: () => void;
}

const BackupSettingsError: React.FC<BackupSettingsErrorProps> = ({
	onClose,
}) => {
	return (
		<>
			<DrawerContent>
				<Stack flex={1} justifyContent="center" alignItems="center">
					<ErrorState>
						There was an error loading your backup settings. Please try again
						later.
					</ErrorState>
				</Stack>
			</DrawerContent>
			<DrawerFooter spacing={100}>
				<Button variant="ghost" onClick={onClose} size="large">
					Close
				</Button>
			</DrawerFooter>
		</>
	);
};

export default BackupSettingsError;
